import React from "react"
import Categories from "views/pages/settings/categories/categories"

function MerchantCategory({
    merchantId,
    placeId,
    merchantInfo
}) {
    return (
        <Categories merchantId={merchantId} placeId={placeId} globalVP={merchantInfo ? merchantInfo?.settings?.valuePackGlobal : true} />
    )
}

export default MerchantCategory